/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputTextAreaFixed/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InputTextAreaFixed({
  children,
  viewPath = "/DesignSystem/InputTextAreaFixed",
  backgroundColor = "#f2f2f2",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  autoComplete = "on",
  autoFocus,
  className,
  fontSize = 16,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  paddingBottom = 16,
  paddingLeft = 16,
  paddingRight = 16,
  paddingTop = 16,
  marginRight = 0,
  marginLeft = 0,
  marginTop = 0,
  marginBottom = 0,
  placeholder,
  resize = "auto",
  type = "text",
  value,
  isDisabled
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<textarea
  data-testid="InputTextAreaFixed.CaptureTextArea"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 placeholder={placeholder}
 value={value}
 disabled={isDisabled}
 style={{'--bc-1-aEb7M': backgroundColor,'--bblr-2-aEb7M': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-aEb7M': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-aEb7M': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-aEb7M': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--fs-6-aEb7M': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--pb-7-aEb7M': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-8-aEb7M': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-9-aEb7M': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-10-aEb7M': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--mr-11-aEb7M': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-12-aEb7M': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-13-aEb7M': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-14-aEb7M': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--r-15-aEb7M': resize}}
 className={`views-capture ${className} ${styles.CaptureTextArea}`}
/>
{children}
</React.Fragment>)
}